import {defineStore} from "pinia/dist/pinia";
import {useAclStore} from "@/store/aclStore";

export const useUserStore = defineStore('UserStore', {
    state() {
        return {
            userState: {}
        }
    },
    getters: {
        user() { return this.userState },
        userRoles() { return this.userState.roles },
        companyCode() { return this.userState.companyCode },
        userAgencyCode() { return this.userState.agencyCode },
        token() { return this.userState != null ?  this.userState.token : null },
    },
    actions: {
        setUser(user) {
            this.userState = user },
        async login(user, vueInstance) {
            this.setUser(user)
            const aclStore = useAclStore()
            aclStore.resetAcl()
            aclStore.createAclRules(user, vueInstance)
        },
        setProfile(profile, vueInstance) {
            this.userState.profile = profile
            this.login(this.userState, vueInstance)
        },
        setToken(token) { this.userState != null ? this.userState.token = token : ''},
    }
})